import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const adminApi = {
  setToken: (token) => {
    if (token) {
      api.defaults.headers.common["X-Admin-Password"] = token;
    } else {
      delete api.defaults.headers.common["X-Admin-Password"];
    }
  },
};

// Initialize admin token from localStorage if present
const savedToken = typeof window !== "undefined" ? localStorage.getItem("admin_token") : null;
if (savedToken) adminApi.setToken(savedToken);

export const formatIDR = (n) => {
  if (n == null || isNaN(n)) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
};
